export default "__VITE_ASSET__iAX0rqBp__"